import { render, staticRenderFns } from "./ExhibitorDetail.vue?vue&type=template&id=46283508&scoped=true"
import script from "./ExhibitorDetail.vue?vue&type=script&lang=js"
export * from "./ExhibitorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46283508",
  null
  
)

export default component.exports